import { Typography, Button, CssBaseline } from '@mui/material';
import { Stack, Box } from '@mui/system';
import { ReactComponent as Logo } from '../components/Layout/logo.svg';
import { useNavigate } from 'react-router-dom';

const LogoutMessagePage = () => {
    const nav = useNavigate();

    const logoutHandler = () => {
        nav('/login');
    };

    return (
        <CssBaseline>
            <Box>
                <Stack
                    sx={{
                        height: '100vh',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: (t) => t.palette.loginBackground.main
                    }}>
                    <Stack sx={{ gap: 2 }}>
                        <Box sx={{ textAlign: 'center', paddingBottom: 2 }}>
                            <Logo width={'90%'} height={100} />
                        </Box>
                        <Stack
                            gap={2}
                            sx={{
                                background: 'white',
                                padding: '25px',
                                borderRadius: '0.625rem',
                                boxShadow: '0 0.125rem 0.375rem 0 #0000001A'
                            }}>
                            <Typography>Your login session has expired</Typography>
                            <Button onClick={logoutHandler} variant="contained" fullWidth>
                                Ok
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
        </CssBaseline>
    );
};

export default LogoutMessagePage;
